<template>
    <div class="wrapper wrapper-content">
        <choose-position-for-analyze
            v-if="active_tab == 'choosing_position'"
            :analyze-type="analyzeType"
            :model="filterPosition"
            :getDocumentsButtonClicked="getDocumentsButtonClicked"
            :showFilters="showFilters"
            :globalFilters="globalFilters"
            :columns-selected="selectedColumns"
            :documents="documents"
            @getDocuments="getDocuments()"
            @resetButtonClicked="resetButtonClicked()"
            @toggleFilterButton="toggleFilterButton()"
            @filter="filter">
        </choose-position-for-analyze>
        <analyze-parameters v-if="active_tab == 'analyze'"
                            :analyze-level="analyze_level"
                            :analyze-type="analyzeType"
                            :analyze-criteria-status="analyzeCriteriasStatus"
        @resetVisibility="handleResetVisibility"
        @criteriumButtonClicked="handleCriteriumButtonClicked"
        @saveCriterias="saveCriterias">

        </analyze-parameters>

        <chart-parameter v-if="active_tab == 'chart'"
                         :analyze-level="analyze_level"
                         :analyze-type="analyzeType"
                        :sb-chart="sbChart"
                         :analyze-criteria-status="analyzeCriteriasStatus"
                         :chartConfig="chartConfig"
                        @chartTypeChange="handleChartTypeChange"
                        @saveSettings="handleSaveSettings"
                         @saveAnalyzeAsPattern="handleSaveAnalyzeAsPattern"
        ></chart-parameter>
        <analyze-tab-component v-if="getDocumentsButtonClicked"
                               :analyze-type="analyzeType"
                               :chart-data="chartData"
                               :columns-selected="selectedColumns"
                               :columns-not-selected="notSelectedColumns"
                               :grouped-columns-selected="groupedSelectedColumns"
                               :table-sort="tableSortState"
                               :documents="visibleDocuments"
                               :active_tab="active_tab"
                               :analyze-criteria-status="analyzeCriteriasStatus"
                               :groupedAndSortedDocumentItems="groupDocumentsByMultipleValues"
                               :analyze-level="analyze_level"
                               :currency="currency"
                               :access="access"
                               :show-analyze-groups="showAnalyzeGroups"
                               @toggle-all="handleToggleAll"
                               @setActiveTab="setActiveTab"
                               @showModal="showTableSettings()"
                               @showGroupedModal="showModal()">
        </analyze-tab-component>
        <!-- ustawienia kolumn zakladki "Analiza"; zakladka "Wybor pozycji" ma standardowy #modalSettings -->
        <settings-modal ref="settings-modal"
                        :columns-selected="groupedSelectedColumns"
                        :columns-not-selected="groupedNotSelectedColumns"
                        :max-selected="13"
                        @saveColumns="handleSaveColumns"
        >
        </settings-modal>
        <modal-edit-contractor-group ref="modal-edit-contractor-group"
                                    :groups="contractorGroups"
                                    @assignContractorsToGroup="assignContractorsToGroup"
                                    @createGroup="handleCreateGroup"
                                    @saveContractorGroups="saveContractorGroups"
                                     @importContractorGroups="importContractorGroups"
                                     @editContractorGroupName="editContractorGroupName"
                                     :analyze-type="analyzeType">

        </modal-edit-contractor-group>
        <modal-assign-to-contractor-group
            ref="assign-to-contractor-group"
            :contractors-and-groups="groupsAndContractorsToAssign">

        </modal-assign-to-contractor-group>
        <modal-create-contractor-group
            ref="create-contractor-group"
            :area="analyzeType"
            :contractors-and-groups="groupsAndContractorsToAssign"
            @groupAdded="handleGroupAdded">

        </modal-create-contractor-group>

        <modal-edit-item-group ref="modal-edit-item-group"
                               :groups="standardItemGroups"
                               @createItemGroup="handleCreateItemGroup"
                               @assignItemsToGroup="assignItemsToGroup"
                               @importItemGroups="importItemGroups"
                               @saveItemGroups="saveItemGroups"
                               @editItemGroupName="editItemGroupName"
                               :analyze-type="analyzeType">
        </modal-edit-item-group>
        <modal-assign-to-item-group
            ref="assign-to-item-group"
            :items-and-groups="groupsAndItemsToAssign">

        </modal-assign-to-item-group>
        <modal-create-item-group
            ref="create-item-group"
            :area="analyzeType"
            :items-and-groups="groupsAndItemsToAssign"
            @itemGroupAdded="handleGroupAdded">

        </modal-create-item-group>
        <modal-edit-currency-group
        ref="modal-edit-currency-group"
        :analyze-type="analyzeType"
        :analyze-level="analyze_level"
        :radio-button-title="radioButtonCurrency"
        @saveCurrenciesGroup="saveCurrenciesGroup">
        </modal-edit-currency-group>

        <modal-edit-date-group
            ref="modal-edit-date-group"
            :analyze-type="analyzeType"
            :analyze-level="analyze_level"
            @saveDateGroup="saveDateGroup">

        </modal-edit-date-group>
        <modal-import-contractor-group
        ref="modal-import-contractor-group"
        :analyze-type="analyzeType"
        @importContractorGroups="handleImportContractorGroups">

        </modal-import-contractor-group>
        <modal-import-item-group
            ref="modal-import-item-group"
            :analyze-type="analyzeType"
            :stock-enabled="stockEnabled"
            :stocks="stocks"
            @importItemGroups="handleImportItemGroups">

        </modal-import-item-group>
        <edit-group-name-modal
            ref="edit-group-name-modal"
            :contractor-groups="contractorGroups"
            :item-groups="standardItemGroups">

        </edit-group-name-modal>
        <store-analyze-pattern  ref="modal-store-analyze-pattern"
                                :analyze-type="analyzeType"
                                :date-type="filterPosition.dateTypeAnalyze"
                                :date-from="filterPosition.dateFrom"
                                :correction="filterPosition.includeCorrectionAnalyze"
                                :search-value="searchValue"
                                :filter-selected-checkbox="globalFilters.checked.length > 0"
                                :analyze-level="analyze_level"
                                :date-to="filterPosition.dateTo"
                                :chart-data="chartData"
                                :global-filters="globalFilters"
                                :selected-columns="groupedSelectedColumns"
                                :item-groups="currentItemsGroups"
                                :contractor-groups="currentContractorsGroups"
                                >

        </store-analyze-pattern>
    </div>
</template>

<script>
import axios from "axios";
import ModalEditItemGroup from "./ModalEditItemGroup";
import ModalEditCurrencyGroup from "./ModalEditCurrencyGroup";
import HelpModal from "../../components/help/HelpModal";
import EditGroupNameModal from "./EditGroupNameModal";
export default {
    name: "SellOrBuyAnalyze",
    components: {EditGroupNameModal, ModalEditCurrencyGroup, ModalEditItemGroup, HelpModal},
    props: {
        analyzeType: {
            type: String
        },
        columnsSelected: {
            type: Array
        },
        columnsNotSelected: {
            type: Array
        },
        // domyslne sortowanie zakladki "Wybor pozycji" z user_columns ({column, direction} albo null)
        tableSort: {
            type: Object,
            default: null
        },
        groupedColumnsSelected: {
            type: Array
        },
        groupedColumnsNotSelected: {
            type: Array
        },
        defaultColumnsSelected: {
            type: Array
        },
        defaultColumnsNotSelected: {
            type: Array
        },
        relatedView: {
            type: String
        },
        radioButtonCurrency:{
            type:String
        },
        currency:{
            type:String
        },
        stockEnabled:{
            type:Number
        },
        stocks:{
            type:Array
        },
        sbChart:{
            type:Array
        },
        access:{
            type: Object
        }
    },
    data: function () {
        return {
            showFilters : false,
            searchValue: '',
            chartData: {},
            chartConfig: {
                type: 0,
                level_1: 0,
                level_2: 0,
                level_3: 0,
            },
            contractorGroups:[],
            standardItemGroups:[],
            filterPosition: {
                dateTypeAnalyze: 'date_issued',
                dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
                dateTo: moment().format('YYYY-MM-DD'),
                includeCorrectionAnalyze: 1,
            },
            analyze_level: {
                analyze_level_1: null,
                analyze_level_2: null,
                analyze_level_3: null,
                currency_segregation:'detailed',
                date_segregation:'month'
            },
            analyzeCriteriasStatus: {},
            active_tab: "choosing_position",
            cleanGlobalFilters: {
                item_name: [],
                symbol: [],
                classification: [],
                item_quantity: [],
                item_unit_of_measure: [],
                item_unit_price: [],
                unit_price_calculation: [],
                item_net_amount: [],
                vat_rate_id: [],
                item_gross_amount: [],
                document_currency: [],
                exchange_rate: [],
                document_number: [],
                date_issued: [],
                sale_date: [],
                contractor_id: [],
                description: [],
                price_before_discount: [],
                discount: [],
                item_vat_rate: [],
                item_vat_amount: [],
                item_vat_refund: [],
                item_vat_refund_amount: [],
                vat_settlement_id: [],
                item_margin: [],
                margin_vat_rate_id: [],
                item_margin_vat_amount: [],
                document_type: [],
                date_received: [],
                contractor_state_id: [],
                margin_type_id: [],
                remarks: [],
                printout_remarks: [],
                contract_description: [],
                contractor_country: [],
                contractor_city: [],
                net_in_base_currency: [],
                checked:[]
            },
            globalFilters: {
                item_name: [],
                symbol: [],
                classification: [],
                item_quantity: [],
                item_unit_of_measure: [],
                item_unit_price: [],
                unit_price_calculation: [],
                item_net_amount: [],
                vat_rate_id: [],
                item_gross_amount: [],
                document_currency: [],
                exchange_rate: [],
                document_number: [],
                date_issued: [],
                sale_date: [],
                contractor_id: [],
                description: [],
                price_before_discount: [],
                discount: [],
                item_vat_rate: [],
                item_vat_amount: [],
                item_vat_refund: [],
                item_vat_refund_amount: [],
                vat_settlement_id: [],
                item_margin: [],
                margin_vat_rate_id: [],
                item_margin_vat_amount: [],
                document_type: [],
                date_received: [],
                contractor_state_id: [],
                margin_type_id: [],
                remarks: [],
                printout_remarks: [],
                contract_description: [],
                contractor_country: [],
                contractor_city: [],
                net_in_base_currency: [],
                checked:[]
            },
            modalVisible: false,
            selectedColumns: [...this.columnsSelected],
            notSelectedColumns: [...this.columnsNotSelected],
            tableSortState: this.tableSort,
            groupedSelectedColumns: [...this.groupedColumnsSelected],
            groupedNotSelectedColumns: [...this.groupedColumnsNotSelected],
            getDocumentsButtonClicked: false,
            documents: [],
            groupsAndContractorsToAssign: [],
            groupsAndItemsToAssign:[],
            visibleDocumentItemIds:[],
            groupedAndSortedDocumentItems:{},
            showAnalyzeGroups:false,
        }
    },
    methods: {
        handleResetVisibility(){
            this.showAnalyzeGroups = false
            this.$set(this.chartData, 'complete', false);
            this.$set(this.chartData, 'crit_1', 0);
            this.$set(this.chartData, 'crit_2', 0);
            this.$set(this.chartData, 'crit_3', 0);
            this.$set(this.chartConfig, 'type', 0);
            this.$set(this.chartConfig, 'level_1', 0);
            this.$set(this.chartConfig, 'level_2', 0);
            this.$set(this.chartConfig, 'level_3', 0);

        },
        handleToggleAll(isChecked) {

            this.documents.forEach(doc => {
                doc.checked = isChecked;
            });
            this.documents = [...this.documents];
        },
        toggleFilterButton(){
            this.showFilters = !this.showFilters
        },
        handleChartTypeChange(prop, value){
            this.$set(this.chartData, prop, value);
            if(prop=='crit_1'){
                this.chartConfig.level_1 = value;
            }
            if(prop=='crit_2'){
                this.chartConfig.level_2 = value;
            }
            if(prop=='crit_3'){
                this.chartConfig.level_3 = value;
            }
            if(prop=='name'){
                this.chartConfig.type = value;
            }
        },
        handleSaveSettings(chartType, firstOption, secondOption, thirdOption){
            toggleLoader();
            const self = this;
            axios.post("/analyze/chart-config/store", {
                area: self.analyzeType,
                chart_type: chartType,
                level_1:firstOption,
                level_2:secondOption,
                level_3:thirdOption,
            }).then(function (response) {
                self.chartConfig = response.data.chart_config
                toggleLoader(false)
            });
        },
        handleSaveAnalyzeAsPattern(chartType, firstOption, secondOption, thirdOption){
            const self = this;
            axios.post("/analyze/get-standard-items-groups", {
                'area': self.analyzeType
            }).then(function (response) {
                self.standardItemGroups = response.data.groups
            });
            axios.post("/analyze/get-contractor-groups", {
                'area': self.analyzeType
            }).then(function (response) {
                self.contractorGroups = response.data.groups
            });
            self.$refs['modal-store-analyze-pattern'].visible = true
            toggleLoader(false)
        },
        importContractorGroups(groups){
            const self = this;
            self.$refs['modal-import-contractor-group'].visible = true
            toggleLoader(false)
        },
        editContractorGroupName(name){
            this.$refs['edit-group-name-modal'].groupName = name;
            this.$refs['edit-group-name-modal'].oldGroupName = name;
            this.$refs['edit-group-name-modal'].type = 'contractors';
            this.$refs['edit-group-name-modal'].visible = true;
        },
        editItemGroupName(name){
            this.$refs['edit-group-name-modal'].groupName = name;
            this.$refs['edit-group-name-modal'].oldGroupName = name;
            this.$refs['edit-group-name-modal'].type = 'items';
            this.$refs['edit-group-name-modal'].visible = true;
        },
        importItemGroups(groups){
            const self = this;
            self.$refs['modal-import-item-group'].visible = true
            toggleLoader(false)
        },
        handleImportContractorGroups(from){
            toggleLoader();
            const self = this;
            axios.post("/analyze/import-contractor-groups", {
                'from': from
            }).then(function (response) {
                self.contractorGroups = response.data.groups
                self.$refs['modal-edit-contractor-group'].contractorGroups = response.data.groups;
                self.$refs['modal-import-contractor-group'].visible = false;
                toggleLoader(false)
            });
        },
        handleImportItemGroups(from, stockId){
            toggleLoader();
            const self = this;
            axios.post("/analyze/import-standard-items-groups", {
                'from': from,
                'stock_id': stockId
            }).then(function (response) {
                self.itemGroups = response.data.groups
                self.$refs['modal-edit-item-group'].itemGroups = response.data.groups;
                self.$refs['modal-import-item-group'].visible = false;
                toggleLoader(false)
            });
        },
        saveContractorGroups(groups){
            const self = this;
            const formData = new FormData();

            groups.forEach((group, groupIndex) => {
                if(group.name != 'unallocated'){
                    formData.append(`contractorGroups[${groupIndex}][group_name]`, group.name);
                    group.contractors.forEach((contractor, contractorIndex) => {
                        if(contractor.id){
                            formData.append(`contractorGroups[${groupIndex}][contractors][${contractorIndex}][id]`, contractor.id);
                        }
                    });
                }
            });
            formData.append('area', self.analyzeType)
            axios.post("/analyze/contractor-groups/store", formData).then(function (response) {
                self.saveVisibleDocumentsItemIds();
                self.documents = response.data.documents;
                self.restoreVisibleDocuments()
                self.analyzeCriteriasStatus = response.data.analyze_criterias
                toggleLoader(false)
                self.$refs['modal-edit-contractor-group'].visible = false
            });
        },
        saveCriterias() {
            toggleLoader();
            const self = this;
            axios.post("/analyze/criterias/store", {
                area: self.analyzeType,
                analyze_levels:self.analyze_level,
            }).then(function (response) {
                self.groupedAndSortedDocumentItems = self.sortKeys()
                self.showAnalyzeGroups = true;
                toggleLoader(false)
            });
        },

        saveItemGroups(groups){
            const self = this;
            const formData = new FormData();
            //zapis grup
            groups.forEach((group, groupIndex) => {
                if(group.name != 'unallocated'){
                    formData.append(`itemGroups[${groupIndex}][group_name]`, group.name);
                    group.standard_items.forEach((standard_item, standardItemIndex) => {
                        if(standard_item.id){
                            formData.append(`itemGroups[${groupIndex}][standard_items][${standardItemIndex}][id]`, standard_item.id);
                        }
                    });
                }
            });
            formData.append('area', self.analyzeType)
            axios.post("/analyze/item-groups/store", formData).then(function (response) {
                self.saveVisibleDocumentsItemIds();
                self.documents = response.data.documents;
                self.restoreVisibleDocuments()
                self.analyzeCriteriasStatus = response.data.analyze_criterias
                toggleLoader(false)
                self.$refs['modal-edit-item-group'].visible = false
            });
        },
        saveCurrenciesGroup(){
            toggleLoader()
            const self = this;
            axios.post("/analyze/currency-groups/store", {
                area: self.analyzeType,
                currency_segregation: self.analyze_level.currency_segregation
            }).then(function (response) {
                if (response.data.status == 'success') {
                    self.saveVisibleDocumentsItemIds();
                    self.documents = response.data.documents;
                    self.restoreVisibleDocuments()
                    self.analyzeCriteriasStatus = response.data.analyze_criterias
                }
                toggleLoader(false);
                self.$refs['modal-edit-currency-group'].visible = false
            });
        },
        saveDateGroup(){
            toggleLoader()
            const self = this;
            axios.post("/analyze/date-groups/store", {
                area: self.analyzeType,
                date_segregation: self.analyze_level.date_segregation,
                date_type: self.filterPosition.dateTypeAnalyze
            }).then(function (response) {
                if (response.data.status == 'success') {
                    self.saveVisibleDocumentsItemIds();
                    self.documents = response.data.documents;
                    self.restoreVisibleDocuments()
                    self.analyzeCriteriasStatus = response.data.analyze_criterias
                }
                toggleLoader(false)
                self.$refs['modal-edit-date-group'].visible = false
            });
        },
        saveVisibleDocumentsItemIds(){
            const visibleDocumentIds = [];

            this.documents.forEach((doc) => {
                if (doc.visible === 1) {
                    visibleDocumentIds.push(doc.id);
                }
            });
            this.visibleDocumentItemIds = visibleDocumentIds;
        },
        restoreVisibleDocuments(){
            const self = this;
            this.documents.forEach((document)=>{
                document.visible = 0;
            })
            this.visibleDocumentItemIds.forEach((itemId) => {
                const documentToUpdate = self.documents.find((doc) => doc.id === itemId);

                if (documentToUpdate) {
                    documentToUpdate.visible = 1;
                }
            });
        },
        handleCriteriumButtonClicked(criterium, status){
            const self = this;
            if(criterium == 'contractor'){
                toggleLoader();
                axios.post("/analyze/get-contractor-groups", {
                    'area': self.analyzeType
                }).then(function (response) {
                    self.contractorGroups = response.data.groups
                    self.$refs['modal-edit-contractor-group'].visible = true;
                    self.$refs['modal-edit-contractor-group'].contractorGroups = response.data.groups;
                    toggleLoader(false)
                });
            }
            else if(criterium == 'item'){
                toggleLoader();
                axios.post("/analyze/get-standard-items-groups", {
                    'area': self.analyzeType
                }).then(function (response) {
                    self.standardItemGroups = response.data.groups
                    self.$refs['modal-edit-item-group'].visible = true;
                    self.$refs['modal-edit-item-group'].itemGroups = response.data.groups;
                    toggleLoader(false)
                });
            }
            else if(criterium == 'currency'){
                self.$refs['modal-edit-currency-group'].visible = true;
            }
            else if(criterium == 'date'){
                self.$refs['modal-edit-date-group'].visible = true;
            }
        },
        setActiveTab(tab) {
            this.active_tab = tab;
        },
        resetButtonClicked() {
            this.globalFilters = JSON.parse(JSON.stringify(this.cleanGlobalFilters))
            this.documents.forEach((obj) => {
                obj.visible = 1;
            });
        },
        filter(searchValue) {
            toggleLoader(true);
            this.searchValue = searchValue
            if (searchValue == null) {
                this.documents.forEach((obj) => {
                    obj.visible = 1;
                });
            } else {
                this.documents.forEach((obj) => {
                    const hasValueX = Object.values(obj).some((value) => {
                        if (typeof value === 'string') {
                            return (
                                value.toLowerCase().includes(searchValue.toLowerCase()) ||
                                value.toLowerCase() == searchValue.toLowerCase()
                            );
                        } else {
                            // Obsługa przypadku, gdy value nie jest łańcuchem znaków
                            return false; // Lub podejmij inne odpowiednie działania
                        }                    });
                    if (!hasValueX) {
                        obj.visible = 0;
                    } else {
                        obj.visible = 1;
                    }
                });
            }
            const filteredGlobalFilters = Object.keys(this.globalFilters)
                .filter((key) => this.globalFilters[key].length > 0)
                .reduce((obj, key) => {
                    obj[key] = this.globalFilters[key].map((item) => item.id);
                    return obj;
                }, {});
            if(Object.keys(filteredGlobalFilters).length > 0){
                this.documents.forEach((document) => {
                    let isDocumentVisible = true;

                    // Iteracja przez klucze w filteredGlobalFilters
                    for (const key in filteredGlobalFilters) {
                        const values = filteredGlobalFilters[key];
                        const documentValue = document[key];

                        // Sprawdzenie, czy wartość document[key] nie istnieje w values
                        if (!values.includes(documentValue)) {
                            isDocumentVisible = false;
                        }
                    }

                    // Zaktualizowanie pola "visible" dokumentu na podstawie wyniku
                    document.visible = isDocumentVisible ? 1 : 0;
                });
            }


            toggleLoader(false);

        },
        // zapis ukladu kolumn zakladki "Analiza" (user_columns analyze_{type}_grouped)
        handleSaveColumns(type, selectedColumns, notSelectedColumns) {
            const self = this;
            toggleLoader()
            axios.post("/analyze/save-columns", {
                area: self.analyzeType,
                type: type,
                selectedColumns:selectedColumns,
                notSelectedColumns:notSelectedColumns,
            }).then(function (response) {
                self.groupedSelectedColumns = response.data.columns_selected;
                self.groupedNotSelectedColumns = response.data.columns_not_selected;
                self.$refs['settings-modal'].visible = false;
                toggleLoader(false)
            }).catch(function (error) {
                // np. limit 13 kolumn (walidacja w SellOrBuyAnalyzeController::saveColumns)
                const errors = error.response && error.response.data && error.response.data.errors;
                self.$refs['settings-modal'].showError(errors ? Object.values(errors)[0][0] : (error.response && error.response.data.message) || String(error));
                toggleLoader(false)
            });
        },
        showTableSettings() {
            $('#modalSettings').modal('show');
        },
        // Standardowy modal ustawien zakladki "Wybor pozycji" (layouts.site.parts.modals) wysyla formularz
        // i przeladowuje strone - tu zgubiloby to pobrana liste, wiec zapis/reset idzie AJAX-em
        // (UserSettingsController odpowiada JSON-em), a kolumny i uklad przypiec pobieramy od nowa.
        submitTableSettings(event) {
            event.preventDefault();
            const self = this;
            const form = event.target;
            const isReset = form.id === 'reset-user-columns';
            toggleLoader();
            axios.post(form.action, new FormData(form), {headers: {Accept: 'application/json'}})
                .then(function () {
                    return axios.post('/analyze/table-columns', {area: self.analyzeType});
                })
                .then(function (response) {
                    self.selectedColumns = response.data.columns_selected;
                    self.notSelectedColumns = response.data.columns_not_selected;
                    self.tableSortState = response.data.sort;
                    // public/js/table-layout.js czyta przypiecia z tego wezla przy kazdym refresh()
                    $('#table-layout').text(JSON.stringify(response.data.layout));
                    if (isReset) {
                        self.resetTableSettingsModal(response.data.columns_selected, response.data.columns_not_selected);
                    }
                    $('#modalSettings').modal('hide');
                })
                .finally(function () {
                    toggleLoader(false);
                });
        },
        // po resecie listy w modalu musza pokazywac domyslne kolumny - przenosimy istniejace <li>
        // (bez przypiec i sortowania); table-settings.js odswieza przyciski przy nastepnym otwarciu
        resetTableSettingsModal(selected, notSelected) {
            const $modal = $('#modalSettings');
            const $selectedList = $modal.find('#user-columns ol.dd-list');
            const $availableList = $modal.find('#nestable3 ol.dd-list');
            const items = {};
            $modal.find('li.dd-item').each(function () {
                items[$(this).attr('data-column')] = this;
                $(this).attr('data-pinned', '0').find('input[name="pinned[]"]').val('0');
            });
            notSelected.forEach(function (column) {
                if (items[column]) $availableList.append(items[column]);
            });
            selected.forEach(function (column) {
                if (items[column]) $selectedList.append(items[column]);
            });
            $availableList.toggleClass('dd-empty', notSelected.length === 0);
            $modal.find('#user-columns input[name="sort_column"], #user-columns input[name="sort_direction"]').val('');
        },
        getDocuments() {
            toggleLoader()
            const self = this;
            axios.post("/analyze/get-documents", {
                area: self.analyzeType,
                date_type: self.filterPosition.dateTypeAnalyze,
                date_from: self.filterPosition.dateFrom,
                date_to: self.filterPosition.dateTo,
                correction: self.filterPosition.includeCorrectionAnalyze
            }).then(function (response) {
                if (response.data.status == 'success') {
                    self.documents = response.data.documents;
                    self.documents.forEach(document => {
                        document.checked = false;
                    });
                    self.getDocumentsButtonClicked = true;
                    self.analyze_level = response.data.analyze_settings;
                    self.analyzeCriteriasStatus = response.data.analyze_criterias;
                    self.chartConfig = response.data.chart_config
                } else {
                    swal(
                        {
                            title: "",
                            text: response.data.message,
                            type: "warning",
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        },
                    );
                }
                toggleLoader(false)
            });
        },

        showModal() {
            // listy Nestable inicjalizuje sam SettingsModal po otwarciu
            this.$refs['settings-modal'].visible = true;
        },
        assignContractorsToGroup(groups){
            this.groupsAndContractorsToAssign = groups;
            this.$refs['assign-to-contractor-group'].visible = true;
        },
        assignItemsToGroup(groups){
            this.groupsAndItemsToAssign = groups;
            this.$refs['assign-to-item-group'].visible = true;
        },
        handleCreateGroup(groups){
            this.groupsAndContractorsToAssign = groups;
            this.$refs['create-contractor-group'].group_name = null;
            this.$refs['create-contractor-group'].visible = true;
        },
        handleCreateItemGroup(groups){
            this.groupsAndItemsToAssign = groups;
            this.$refs['create-item-group'].group_name = null;
            this.$refs['create-item-group'].visible = true;
        },
        handleGroupAdded(groups){
            this.groupsAndContractorsToAssign = groups;
        },
        handleItemGroupAdded(groups){
            this.groupsAndItemsToAssign = groups;
        },
        sortKeys(){
            // Przekształć klucze na tablicę i posortuj ją z uwzględnieniem bardziej złożonych reguł
            const sortedKeys = Object.keys(this.groupDocumentsByMultipleValues).sort((a, b) => {
                const partsA = a.split('_');
                const partsB = b.split('_');

                for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
                    const numA = parseInt(partsA[i], 10);
                    const numB = parseInt(partsB[i], 10);

                    if (numA < numB) {
                        return -1;
                    }
                    if (numA > numB) {
                        return 1;
                    }
                }

                if (partsA.length < partsB.length) {
                    return -1;
                }
                if (partsA.length > partsB.length) {
                    return 1;
                }

                return 0;
            });

            // Utwórz nowy obiekt z posortowanymi kluczami
            const sortedGroupedData = {};
            sortedKeys.forEach((key) => {
                sortedGroupedData[key] = this.groupDocumentsByMultipleValues[key];
            });
            return sortedGroupedData;
        }
    },
    mounted() {
        $(document).on('submit.analyzeTableSettings', '#user-columns, #reset-user-columns', this.submitTableSettings);
    },
    beforeDestroy() {
        $(document).off('submit.analyzeTableSettings');
    },
    computed: {
        currentItemsGroups(){
            let itemGroups = [];
            this.standardItemGroups.forEach((group, groupIndex) => {
                if(group.name != 'unallocated'){
                    let groupData = {
                        group_name: group.name,
                        standard_items: []
                    };
                    group.standard_items.forEach((standard_item, standardItemIndex) => {
                        if(standard_item.id){
                            groupData.standard_items.push({ id: standard_item.id });
                        }
                    });
                    itemGroups.push(groupData);
                }
            });
            return itemGroups;
        },
        currentContractorsGroups(){
            let contractorGroups = [];
            this.contractorGroups.forEach((group, groupIndex) => {
                if(group.name != 'unallocated'){
                    let groupData = {
                        group_name: group.name,
                        contractors: []
                    };
                    group.contractors.forEach((contractor, standardItemIndex) => {
                        if(contractor.id){
                            groupData.contractors.push({ id: contractor.id });
                        }
                    });
                    contractorGroups.push(groupData);
                }
            });
            return contractorGroups;
        },
        visibleDocuments: function () {
            return this.documents.filter(item => {
                return item.visible == 1;
            })
        },
        computedOrder() {
            const orderMapping = {
                contractor: "contractor_item_order",
                item: "order_item_order",
                currency: "currency_item_order",
                date: "date_item_order",
            };

            const result = {};

            for (const key in this.analyze_level) {
                if (this.analyze_level[key] !== null && orderMapping[this.analyze_level[key]]) {
                    result[key] = orderMapping[this.analyze_level[key]];
                }
            }

            return result;
        },
        groupDocumentsByMultipleValues() {
            const groupBy = Object.values(this.computedOrder);
            const groupedData = {};
            let documents = this.documents.filter(item=>{
                return item.visible == 1;
            })
            documents.forEach((document) => {
                const groupByValues = groupBy.map((key) => document[key]);
                const groupKey = groupByValues.join("_");

                if (!groupedData[groupKey]) {
                    groupedData[groupKey] = [];
                }

                groupedData[groupKey].push(document);
            });
            const sortedKeys = Object.keys(groupedData).sort((a, b) => {
                const partsA = a.split('_');
                const partsB = b.split('_');

                for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
                    const numA = parseInt(partsA[i], 10);
                    const numB = parseInt(partsB[i], 10);

                    if (numA < numB) {
                        return -1;
                    }
                    if (numA > numB) {
                        return 1;
                    }
                }

                if (partsA.length < partsB.length) {
                    return -1;
                }
                if (partsA.length > partsB.length) {
                    return 1;
                }

                return 0;
            });

            // Utwórz nowy obiekt z posortowanymi kluczami
            const sortedGroupedData = {};
            sortedKeys.forEach((key) => {
                sortedGroupedData[key] = groupedData[key];
            });
            return sortedGroupedData;


        },
    }

    }
</script>

<style scoped>

</style>
